function initCollectionDescToggle() {
  var desc = document.getElementById('collection-desc');
  var toggle = document.getElementById('collection-desc-toggle');
  if (!desc || !toggle) return;
  setTimeout(function() {
    if (desc.scrollHeight <= desc.clientHeight + 5) {
      toggle.style.display = 'none';
      return;
    }
    toggle.style.display = 'block';
    toggle.addEventListener('click', function() {
      var isExpanded = desc.classList.toggle('expanded');
      toggle.textContent = isExpanded ? 'Voir moins' : 'Voir plus';
      toggle.setAttribute('aria-expanded', isExpanded);
    });
  }, 300);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionDescToggle);
} else {
  initCollectionDescToggle();
}
